module.exports = __webpack_public_path__ + "static/TiemposText-SemiboldItalic-296bba651983fe36b88edd9efa5d0713.woff";